import { render, staticRenderFns } from "./PortfolioWidget.vue?vue&type=template&id=6adbf46c&"
import script from "./PortfolioWidget.vue?vue&type=script&lang=ts&"
export * from "./PortfolioWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports